import { useEffect, useState } from 'react';
import { clothingSvgContent } from '../../constants/clothingSvgContent';

const svgCache = {};

function processSvg(svgText, color, shirtColor, tieColor, blouseColor) {
    try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(svgText, 'image/svg+xml');
        // Bail out if DOMParser produced a parse error document
        if (doc.documentElement.nodeName === 'parsererror') return svgText;
        const svgEl = doc.documentElement;
        svgEl.setAttribute('width', '100%');
        svgEl.setAttribute('height', '100%');
        if (color) {
            doc.querySelectorAll('.dress-fill').forEach(el => el.setAttribute('fill', color));
        }
        if (shirtColor) {
            doc.querySelectorAll('.shirt-fill').forEach(el => el.setAttribute('fill', shirtColor));
        }
        if (tieColor) {
            doc.querySelectorAll('.tie-fill').forEach(el => el.setAttribute('fill', tieColor));
        }
        if (blouseColor) {
            doc.querySelectorAll('.blouse-fill').forEach(el => el.setAttribute('fill', blouseColor));
        }
        return new XMLSerializer().serializeToString(svgEl);
    } catch {
        return svgText;
    }
}

export function DressPreviewSvg({ src, color, shirtColor, tieColor, blouseColor, alt, className, style, onError }) {
    // Read bundled SVGs directly at render time — always fresh, HMR-safe
    const bundledSvg = clothingSvgContent[src];

    // Only use state for SVGs that need a runtime fetch (not in the bundle)
    const [fetchedSvg, setFetchedSvg] = useState(() => svgCache[src] || null);

    useEffect(() => {
        if (bundledSvg || !src) return;
        if (svgCache[src]) {
            setFetchedSvg(svgCache[src]);
            return;
        }
        fetch(src)
            .then(r => {
                if (!r.ok) throw new Error(`HTTP ${r.status}`);
                return r.text();
            })
            .then(text => {
                svgCache[src] = text;
                setFetchedSvg(text);
            })
            .catch(() => setFetchedSvg(null));
    }, [src, bundledSvg]);

    const rawSvg = bundledSvg || fetchedSvg;

    if (!rawSvg) {
        return <img src={src} alt={alt} className={className} style={style} onError={onError} />;
    }

    return (
        <span
            className={className}
            style={{ display: 'block', width: '100%', height: '100%', lineHeight: 0, ...style }}
            dangerouslySetInnerHTML={{ __html: processSvg(rawSvg, color, shirtColor, tieColor, blouseColor) }}
        />
    );
}
